import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'app-standard-progress-bar',
    templateUrl: './standard-progress-bar.component.html',
    styleUrl: './standard-progress-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StandardProgressBarComponent {
    public value = input<number>(0);
}
